import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

/** Shown while the conversation is being read, in every tab that needs it. */
export function DebugLoading() {
  const { t } = useTranslation();

  return (
    <p className="flex items-center gap-2 text-muted-foreground text-sm">
      <Loader2 className="size-4 animate-spin" />
      {t("chat.debug.loading")}
    </p>
  );
}

/** A quoted message excerpt, or nothing when the message never spoke. */
export function DebugQuote({
  text,
  className,
}: {
  text: string | null;
  className?: string;
}) {
  if (!text) return null;

  return <p className={className ?? "text-xs italic"}>« {text} »</p>;
}

/** A coloured dot standing for one block of the context window. */
export function SegmentDot({
  color,
  size = "sm",
}: {
  color: string;
  size?: "sm" | "md";
}) {
  return (
    <span
      className={cn("shrink-0 rounded-full", size === "sm" ? "size-2" : "size-2.5")}
      style={{ backgroundColor: color }}
    />
  );
}
